// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.side_menu[data-v-f763bce2] {\n  padding-left: 0px;\n}\n.mudai[data-v-f763bce2] {\n  color: #ccc;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
